export default {
      id: "options-2-24-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#options-2-24-usage",
      toString: function () {
        return this.url;
      }
    }